// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Loading from '../../_common/Loading';
import Page from '../pageLayout/Page';
import ContactCards from './ContactCards';
import { htmlDecode, mobileView } from '../../_common/api/utility';
import { HamQuest } from '../../../App';

const Row = styled.div`
    display: flex;
    margin: 1em 0;
    justify-content: space-around;
    flex-flow: row wrap;

    ${({ mobile }) => mobile && `
        flex-direction: column;
        align-items: center;
    `}
`

const About = () => {
    const { state: {
        // mobileView,
    } } = useGlobalState();

    const [support, setSupport] = useState(null)

    useEffect(() => {
        HamQuest.get(QuestRoute.merchant.support)
            .then(res => setSupport({
                email: res.supportEmail,
                phone: res.supportPhone,
                faq: htmlDecode(res.supportFaqs),
            }))
    }, [])

    return !support ? <Loading /> : (
        <Page key='aboutUs'>
            <Row mobile={mobileView}>
                {support.phone ? <ContactCards type='phone' value={support.phone} /> : null}
                {support.email ? <ContactCards type='email' value={support.email} /> : null}
            </Row>
            {support.faq ? <div dangerouslySetInnerHTML={{ __html: support.faq }} /> : null}
        </Page>
    );
}

export default About;